import { render, staticRenderFns } from "./RemoveItemsModal.vue?vue&type=template&id=e296e968"
import script from "./RemoveItemsModal.vue?vue&type=script&lang=js"
export * from "./RemoveItemsModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveItemsModal.vue?vue&type=style&index=0&id=e296e968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports